import { Injectable, Inject, LOCALE_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private currentLocale: string = 'pt-br';

  constructor(@Inject(LOCALE_ID) private localeId: string) {
    this.currentLocale = localeId;
  }

  setLocale(locale: string) {
    this.currentLocale = locale;
  }

  getLocale(): string {
    return this.currentLocale;
  }
}
